<mat-card appearance="outlined" class="stxr-card" *ngIf="serviceProviderId != null">
  <mat-card-title>
    <span i18n="@@Exemption Review Queue">Exemption Review Queue</span>
    <button mat-icon-button (click)="refreshQueue()" [disabled]="queueLoading"
            title="Refresh" i18n-title="@@Refresh">
      <mat-icon>refresh</mat-icon>
    </button>
  </mat-card-title>
  <mat-card-content>
    <div *ngIf="queueLoading" class="stxr-row">
      <mat-spinner diameter="20"></mat-spinner>
      <span i18n="@@Loading data">Loading data</span>
    </div>
    <div class="stxr-error" *ngIf="queueError">{{queueError}}</div>

    <table *ngIf="!queueLoading && queue.length > 0" class="stxr-queue-table">
      <thead>
        <tr>
          <th i18n="@@Organization">Organization</th>
          <th i18n="@@Type">Type</th>
          <th i18n="@@Status">Status</th>
          <th i18n="@@Submitted">Submitted</th>
          <th i18n="@@States">States</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let it of queue"
            [class.stxr-selected]="selectedItem?.orgId === it.orgId">
          <td>{{it.orgName}} <span class="stxr-mute">({{it.orgId}})</span></td>
          <td>{{typeLabel(it.type)}}</td>
          <td>{{statusLabel(it.status)}}</td>
          <td>{{it.submittedAt | date:'short'}}</td>
          <td>{{it.exemptStatesCount}}</td>
          <td>
            <button mat-stroked-button (click)="open(it)" i18n="@@Review">Review</button>
          </td>
        </tr>
      </tbody>
    </table>
    <div *ngIf="!queueLoading && queue.length === 0" class="stxr-mute"
         i18n="@@noExemptionRequests">No pending exemption requests for this Service Provider.</div>
  </mat-card-content>
</mat-card>

<mat-card appearance="outlined" class="stxr-card" *ngIf="selectedItem">
  <mat-card-title>
    <span i18n="@@Exemption Details">Exemption Details</span>
    <span class="stxr-mute">— {{selectedItem.orgName}} ({{selectedItem.orgId}})</span>
    <button mat-icon-button (click)="close()" title="Close" i18n-title="@@Close">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-title>
  <mat-card-content>
    <div *ngIf="selectedLoading" class="stxr-row">
      <mat-spinner diameter="20"></mat-spinner>
      <span i18n="@@Loading data">Loading data</span>
    </div>

    <div class="stxr-error" *ngIf="selectedError">{{selectedError}}</div>

    <ng-container *ngIf="selectedExemption && !selectedLoading">
      <div class="stxr-row">
        <strong i18n="@@Status">Status</strong>: {{statusLabel(selectedExemption.status)}}
      </div>
      <div class="stxr-row">
        <strong i18n="@@Type">Type</strong>: {{typeLabel(selectedExemption.type)}}
      </div>
      <div class="stxr-row" *ngIf="selectedExemption.certificate">
        <strong i18n="@@Certificate">Certificate</strong>:
        #{{selectedExemption.certificate.number}}
        (<span i18n="@@issued by">issued by</span> {{selectedExemption.certificate.issuingState}})
        — {{selectedExemption.certificate.fileName}}
        <button mat-stroked-button (click)="openCertificate()" i18n="@@View Certificate">View Certificate</button>
      </div>

      <div *ngIf="isCertificateImage() && selectedExemption.certificateUrl" class="stxr-cert-image">
        <img i18n-alt="@@Sales tax certificate" [src]="selectedExemption.certificateUrl" alt="Sales tax certificate" />
      </div>

      <h4 i18n="@@Requested States">Requested States</h4>
      <div class="stxr-state-chips">
        <span class="stxr-chip" *ngFor="let s of selectedExemption.exemptStates">{{s}}</span>
      </div>

      <h4 i18n="@@Reviewer Decision">Reviewer Decision</h4>
      <div class="stxr-form-row">
        <mat-form-field appearance="outline">
          <mat-label i18n="@@Accepted Type">Accepted Type</mat-label>
          <mat-select [(value)]="reviewerAcceptedType">
            <mat-option value="other" i18n="@@other">other</mat-option>
            <mat-option value="wholesale" i18n="@@wholesale">Wholesale</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="stxr-help" i18n="@@helpAcceptedStates">Edit the set of states to accept exemption for. Cells outside the Service Provider's nexus are shown as no-nexus.</div>
      <app-sales-tax-states-matrix
        [config]="salesTaxConfig"
        [type]="reviewerAcceptedType"
        [issuingState]="selectedExemption.certificate ? selectedExemption.certificate.issuingState : ''"
        [(selectedStates)]="reviewerAcceptedStates">
      </app-sales-tax-states-matrix>

      <mat-form-field appearance="outline" style="width: 100%; margin-top: 12px;">
        <mat-label i18n="@@Message to Organization">Message to Organization</mat-label>
        <textarea matInput rows="3" [(ngModel)]="reviewerMessage"></textarea>
      </mat-form-field>

      <div class="stxr-actions">
        <button mat-flat-button color="primary"
                [disabled]="reviewerActing"
                (click)="act('ACCEPT')" i18n="@@Accept">Accept</button>
        <button mat-stroked-button
                [disabled]="reviewerActing"
                (click)="act('REQUEST_INFO')" i18n="@@Request Info">Request Info</button>
        <button mat-stroked-button color="warn"
                [disabled]="reviewerActing"
                (click)="act('REJECT')" i18n="@@Reject">Reject</button>
        <button mat-stroked-button color="warn"
                *ngIf="selectedExemption.status === 'ACCEPTED'"
                [disabled]="reviewerActing"
                (click)="act('REVOKE')" i18n="@@Revoke">Revoke</button>
        <mat-spinner *ngIf="reviewerActing" diameter="18"></mat-spinner>
      </div>

      <div *ngIf="reviewerWarnings.length > 0" class="stxr-warning-list">
        <div *ngFor="let w of reviewerWarnings" class="stxr-warning">
          <mat-icon>warning</mat-icon>
          <span><strong>{{w.code}}</strong> — {{w.message}}</span>
        </div>
      </div>

      <div *ngIf="selectedExemption.messages?.length" class="stxr-messages">
        <h4 i18n="@@Conversation">Conversation</h4>
        <div *ngFor="let m of selectedExemption.messages" class="stxr-message">
          <div class="stxr-message-head">
            <strong>{{m.userName}}</strong>
            <span class="stxr-mute">({{m.from}})</span>
            <span class="stxr-mute">{{m.at | date:'short'}}</span>
          </div>
          <div class="stxr-message-text">{{m.text}}</div>
        </div>
      </div>
    </ng-container>
  </mat-card-content>
</mat-card>

